import { createSlice } from "@reduxjs/toolkit"

interface MetricState {
  tabs: Array<Object>
  groups: Array<Object>
  groupList: Array<any>
  regionList: Array<any>
  selectedTab: any
  selectedGroups: Array<any>
  selectedBlueprintMetrics: any
  metricBMTableData: any

  //Common

  maevaGroups: Array<any>
  maevaRegions: Array<any>
  maevaPractices: Array<any>
  maevaClasses: Array<any>
  maevaSelectedGroups: Array<any>
  maevaSelectedRegions: Array<any>
  maevaSelectedPractices: Array<any>
  maevaSelectedClasses: Array<any>
  maevaSelectedGroupsNoAll: Array<any>
  maevaSelectedRegionsNoAll: Array<any>
  maevaSelectedPracticesNoAll: Array<any>
  maevaSelectedClassesNoAll: Array<any>
  maevaSelectedDateRange: any

  //Goals
  metricGoalsData: Array<any>
  metricGoalsTableData: Array<any>
  metricGoalsSelectedGroup: any
  metricGoalsRegionList: Array<any>
  metricGoalsSelectedRegion: any
  metricGoalsPracticeList: Array<any>
  metricGoalsSelectedPractice: any
  metricGoalsSelectedYear: any
  metricGoalsTabs: any
  selectedMetricGoalsTab: any
  metricGoalsYearList: Array<any>

  //opportunitydashboard
  opportunityTableData: Array<any>
  opportunityGroupList: Array<any>
  opportunityRegionList: Array<any>
  opportunitySelectedRegion: any
  opportunitySelectedYear: any
  selectedOpportunityTab: any
  opportunityTabs: any
  opportunityPracticeList: Array<any>
  opportunitySelectedPractice: any
  opportunityYearList: Array<any>
  opportunitySelectedAdvisor: any
  opportunityAdvisorList: Array<any>
  opportunityStatusList: Array<any>
  opportunityHeaderStatusList: Array<any>
  opportunitySelectedStatusList: any
  opportunityMoreColumns: Array<any>
  opportunityName: any
  officeName: any
  opportunityStatus: any
  opportunityLogs: Array<any>
  opportunityEditGoalTable: Array<any>
  opportunityPracticeSk: any
  opportunityGroupSk: any
  opportunityRegion: any
  opportunityMetricId: any
  opportunityEditGoalYear: any
  opportunityAvailableYears: Array<any>
  opportunitySelectedStatus: any
  opportunityFetchId: any
  opportunityViewHistorical: Array<any>
  opportunitySelectedGroupByRole: any
  opportunityGroupListByRole: Array<any>

  // Opportunity
  metricOpportunityHeaderGroups: any
  metricOpportunityHeaderRegions: any
  metricOpportunityHeaderPractices: any
  metricOpportunityHeaderYears: any
  metricOpportunityHeaderFilterSelectedGroup: any
  metricOpportunityHeaderFilterSelectedRegion: any
  metricOpportunityHeaderFilterSelectedPractice: any
  metricOpportunityHeaderFilterSelectedYear: any

  metricOpportunityData: Array<any>
  metricOpportunityTableData: Array<any>
  metricOpportunityTableDataFiltered: Array<any>
  expandedD: { [key: string]: boolean }

  metricOpportunityTabs: any
  selectedMetricOpportunityTab: any
  selectedOpportunityColumnFilters: any

  metricOpportunityModalOpen: any
  metricOpportunityActiveRow: any

  metricOpportunityColumnFilterSelectValues: any

  metricOpportunityDetail: any
}

const initialState: MetricState = {
  tabs: [],
  groups: [],
  groupList: [],
  regionList: [],
  selectedTab: 0,
  selectedGroups: [],
  selectedBlueprintMetrics: [],
  metricBMTableData: [],

  // Common

  maevaGroups: [],
  maevaRegions: [],
  maevaPractices: [],
  maevaClasses: [],

  maevaSelectedGroups: [],
  maevaSelectedRegions: [],
  maevaSelectedPractices: [],
  maevaSelectedClasses: [],

  maevaSelectedGroupsNoAll: [],
  maevaSelectedRegionsNoAll: [],
  maevaSelectedPracticesNoAll: [],
  maevaSelectedDateRange: [],
  maevaSelectedClassesNoAll: [],

  //Goals
  metricGoalsData: [],
  metricGoalsTableData: [],
  metricGoalsSelectedGroup: null,
  metricGoalsRegionList: [],
  metricGoalsSelectedRegion: {
    label: "All",
    region: "all",
  },
  metricGoalsPracticeList: [],
  metricGoalsSelectedPractice: {
    label: "All",
  },
  metricGoalsSelectedYear: null,
  metricGoalsYearList: [
    {
      label: "2024",
    },
    {
      label: "2023",
    },
    {
      label: "2022",
    },
    {
      label: "2021",
    },
  ],
  metricGoalsTabs: [],
  selectedMetricGoalsTab: 0,

  //opportunity dashboard

  opportunityTableData: [],

  opportunityAdvisorList: [],
  opportunitySelectedAdvisor: {
    label: "All",
    uid: "all",
  },
  opportunityGroupList: [],
  opportunityRegionList: [],
  opportunitySelectedRegion: {
    label: "All",
    region: "all",
  },
  opportunityPracticeList: [],
  opportunitySelectedPractice: {
    label: "All",
    practice_sk: "all",
  },

  opportunityStatusList: [],
  opportunitySelectedStatusList: {
    label: "All",
    status: "all",
  },

  opportunityHeaderStatusList: [],
  opportunityGroupListByRole: [],
  opportunitySelectedGroupByRole: {
    label: "All",
    group_sk: "all",
  },

  opportunitySelectedYear: null,
  selectedOpportunityTab: 0,
  opportunityTabs: [],
  opportunityYearList: [
    {
      label: "2024",
    },
    {
      label: "2023",
    },
    {
      label: "2022",
    },
    {
      label: "2021",
    },
  ],
  opportunityMoreColumns: [],
  opportunityName: null,
  officeName: null,
  opportunityStatus: null,
  opportunityLogs: [],
  opportunityEditGoalTable: [],
  opportunityPracticeSk: null,
  opportunityGroupSk: null,
  opportunityRegion: null,
  opportunityMetricId: null,
  opportunityEditGoalYear: null,
  opportunityAvailableYears: [],
  opportunitySelectedStatus: null,
  opportunityFetchId: null,
  opportunityViewHistorical: [],

  // Opportunity

  metricOpportunityHeaderGroups: [],
  metricOpportunityHeaderRegions: [],
  metricOpportunityHeaderPractices: [],
  metricOpportunityHeaderYears: [
    {
      label: "2024",
    },
    {
      label: "2023",
    },
    {
      label: "2022",
    },
    {
      label: "2021",
    },
  ],

  metricOpportunityHeaderFilterSelectedGroup: {
    label: "All",
    group_sk: "all",
  },
  metricOpportunityHeaderFilterSelectedRegion: {
    label: "All",
    region: "all",
  },
  metricOpportunityHeaderFilterSelectedPractice: {
    label: "All",
    practice_sk: "all",
  },
  metricOpportunityHeaderFilterSelectedYear: {
    label: "2023",
  },

  metricOpportunityData: [],
  metricOpportunityTableData: [],
  metricOpportunityTableDataFiltered: [],
  expandedD: {},

  metricOpportunityTabs: [],
  selectedMetricOpportunityTab: 0,
  selectedOpportunityColumnFilters: Array(40).fill(""),
  metricOpportunityModalOpen: false,
  metricOpportunityActiveRow: {},
  metricOpportunityColumnFilterSelectValues: Array(40).fill(""),
  metricOpportunityDetail: null,
}

const metricSlice: any = createSlice({
  name: "metric",
  initialState,
  reducers: {
    setTabs: (state, action) => {
      state.tabs = action.payload
    },
    setGroups: (state, action) => {
      state.groups = action.payload
    },
    setSelectedTab: (state, action) => {
      state.selectedTab = action.payload
    },
    setSelectedGroups: (state, action) => {
      state.selectedGroups = action.payload
    },
    setGroupList: (state, action) => {
      state.groupList = action.payload
    },
    setSelectedBlueprintMetrics: (state, action) => {
      // state.selectedBlueprintMetrics = action.payload

      const { isChecked, metric_id, metric_bucket_id, metric_name } =
        action.payload

      // if (!isChecked) {
      //   state.selectedBlueprintMetrics = []
      // }

      if (isChecked == true) {
        state.selectedBlueprintMetrics = [
          ...state.selectedBlueprintMetrics,
          { metric_bucket_id, metric_id, metric_name },
        ]
      } else if (isChecked == false) {
        state.selectedBlueprintMetrics = state.selectedBlueprintMetrics.filter(
          (obj: any) => obj.metric_id !== metric_id,
        )
      }
    },
    setSelectedBlueprintMetricsEmpty: (state) => {
      state.selectedBlueprintMetrics = []
    },
    setMetricBMTableData: (state, action) => {
      state.metricBMTableData = action.payload
    },

    // Common

    setMaevaGroups: (state, action) => {
      state.maevaGroups = action.payload
    },
    setMaevaRegions: (state, action) => {
      state.maevaRegions = action.payload
    },
    setMaevaPractices: (state, action) => {
      state.maevaPractices = action.payload
    },
    setMaevaClasses: (state, action) => {
      state.maevaClasses = action.payload
    },
    // Cascade: when group changes (with "All" variant), clear downstream for consistency.
    setMaevaSelectedGroups: (state, action) => {
      state.maevaSelectedGroups = action.payload
      state.maevaSelectedRegionsNoAll = []
      state.maevaSelectedPracticesNoAll = []
      state.maevaSelectedClassesNoAll = []
      state.maevaSelectedRegions = []
      state.maevaSelectedPractices = []
    },
    setMaevaSelectedRegions: (state, action) => {
      state.maevaSelectedRegions = action.payload
      state.maevaSelectedPracticesNoAll = []
      state.maevaSelectedPractices = []
    },
    setMaevaSelectedPractices: (state, action) => {
      state.maevaSelectedPractices = action.payload
    },
    setMaevaSelectedClasses: (state, action) => {
      state.maevaSelectedClasses = action.payload
    },
    // Cascade: when group changes, clear all downstream filters so no module shows
    // stale region/practice/class from a previous group (e.g. Resource Budget after
    // user changed group on P&L Budget). Single source of truth: no caller needs to
    // clear region/practice/class when changing group. Optional later: validate
    // selected region/practice belong to current group on page mount if needed.
    setMaevaSelectedGroupsNoAll: (state, action) => {
      state.maevaSelectedGroupsNoAll = action.payload
      state.maevaSelectedRegionsNoAll = []
      state.maevaSelectedPracticesNoAll = []
      state.maevaSelectedClassesNoAll = []
      state.maevaSelectedRegions = []
      state.maevaSelectedPractices = []
    },
    // Cascade: when region changes, clear practice so selection stays valid.
    setMaevaSelectedRegionsNoAll: (state, action) => {
      state.maevaSelectedRegionsNoAll = action.payload
      state.maevaSelectedPracticesNoAll = []
      state.maevaSelectedPractices = []
    },
    setMaevaSelectedPracticesNoAll: (state, action) => {
      state.maevaSelectedPracticesNoAll = action.payload
    },
    setMaevaSelectedClassesNoAll: (state, action) => {
      state.maevaSelectedClassesNoAll = action.payload
    },
    setMaevaSelectedDateRange: (state, action) => {
      state.maevaSelectedDateRange = action.payload
    },

    // Goals

    setMetricGoalsData: (state, action) => {
      state.metricGoalsData = action.payload
    },
    setMetricGoalsTableData: (state, action) => {
      state.metricGoalsTableData = action.payload
    },
    setMetricGoalsSelectedGroup: (state, action) => {
      state.metricGoalsSelectedGroup = action.payload
    },
    setMetricGoalsRegionList: (state, action) => {
      state.metricGoalsRegionList = action.payload
    },
    setMetricGoalsSelectedRegion: (state, action) => {
      state.metricGoalsSelectedRegion = action.payload
    },
    setMetricGoalsPracticeList: (state, action) => {
      state.metricGoalsPracticeList = action.payload
    },
    setMetricGoalsSelectedPractice: (state, action) => {
      state.metricGoalsSelectedPractice = action.payload
    },
    setMetricGoalsSelectedYear: (state, action) => {
      state.metricGoalsSelectedYear = action.payload
    },
    setMetricGoalsTabs: (state, action) => {
      state.metricGoalsTabs = action.payload
    },
    setSelectedMetricGoalsTab: (state, action) => {
      state.selectedMetricGoalsTab = action.payload
    },
    setMetricGoalsYearList: (state, action) => {
      state.metricGoalsYearList = action.payload
    },

    //opportunitydashboard
    setOpportunityTableData: (state, action) => {
      state.opportunityTableData = action.payload
    },
    setOpporunityYearList: (state, action) => {
      state.opportunityYearList = action.payload
    },
    setOpportunityPracticeList: (state, action) => {
      state.opportunityPracticeList = action.payload
    },
    setOpportunitySelectedPractice: (state, action) => {
      state.opportunitySelectedPractice = action.payload
    },
    setOpportunityTabs: (state, action) => {
      state.opportunityTabs = action.payload
    },
    setSelectedOportunityTab: (state, action) => {
      state.selectedOpportunityTab = action.payload
    },
    setOpportunityGroupList: (state, action) => {
      state.opportunityGroupList = action.payload
    },
    setOpportunityGroupListByRole: (state, action) => {
      state.opportunityGroupListByRole = action.payload
    },
    setOpportunitySelectedGroupByRole: (state, action) => {
      state.opportunitySelectedGroupByRole = action.payload
    },
    setOpportunityRegionList: (state, action) => {
      state.opportunityRegionList = action.payload
    },
    setOpportunitySelectedRegion: (state, action) => {
      state.opportunitySelectedRegion = action.payload
    },
    setOpportunitySelectedYear: (state, action) => {
      state.opportunitySelectedYear = action.payload
    },
    setOpportunityAdvisorList: (state, action) => {
      state.opportunityAdvisorList = action.payload
    },
    setOpportunitySelectedAdvisor: (state, action) => {
      state.opportunitySelectedAdvisor = action.payload
    },
    setOpportunityStatusList: (state, action) => {
      state.opportunityStatusList = action.payload
    },
    setOpportunityHeaderStatusList: (state, action) => {
      state.opportunityHeaderStatusList = action.payload
    },
    setOpportunitySelectedStatusList: (state, action) => {
      state.opportunitySelectedStatusList = action.payload
    },
    setOpportunityMoreColumns: (state, action) => {
      state.opportunityMoreColumns = action.payload
    },
    setOpportunityName: (state, action) => {
      state.opportunityName = action.payload
    },
    setOppoortunityOfficeName: (state, action) => {
      state.officeName = action.payload
    },
    setOpportunityStatus: (state, action) => {
      state.opportunityStatus = action.payload
    },
    setOpportunityLogs: (state, action) => {
      state.opportunityLogs = action.payload
    },
    setOpportunityPracticeSk: (state, action) => {
      state.opportunityPracticeSk = action.payload
    },
    setOpportunityGroupSk: (state, action) => {
      state.opportunityGroupSk = action.payload
    },
    setOpportunityRegion: (state, action) => {
      state.opportunityRegion = action.payload
    },
    setOppoortunityMetricId: (state, action) => {
      state.opportunityMetricId = action.payload
    },
    setOpportunityEditGoalYear: (state, action) => {
      state.opportunityEditGoalYear = action.payload
    },
    setOpportunityEditGoalTable: (state, action) => {
      state.opportunityEditGoalTable = action.payload
    },
    setOpportunityAvailableYears: (state, action) => {
      state.opportunityAvailableYears = action.payload
    },
    setOpportunitySelectedStatus: (state, action) => {
      state.opportunitySelectedStatus = action.payload
    },
    setOpportunityFetchId: (state, action) => {
      state.opportunityFetchId = action.payload
    },
    setOpportunityViewHistorical: (state, action) => {
      state.opportunityViewHistorical = action.payload
    },

    // Opportunity
    setMetricOpportunityColumnFilterSelectValues: (state, action) => {
      const { filterColor, index } = action.payload
      state.metricOpportunityColumnFilterSelectValues[index] = filterColor
    },
    setMetricOpportunityData: (state, action) => {
      state.metricOpportunityData = action.payload
    },
    setMetricOpportunityTableData: (state, action) => {
      state.metricOpportunityTableData = action.payload
    },
    setMetricOpportunityTableDataFiltered: (state, action) => {
      state.metricOpportunityTableDataFiltered = action.payload
    },
    setExpandedD: (state, action) => {
      state.expandedD = action.payload
    },
    setMetricOpportunityGroups: (state, action) => {
      state.metricOpportunityHeaderGroups = action.payload
    },
    setMetricOpportunityRegions: (state, action) => {
      state.metricOpportunityHeaderRegions = action.payload
    },
    setMetricOpportunityPractices: (state, action) => {
      state.metricOpportunityHeaderPractices = action.payload
    },
    setMetricOpportunityYears: (state, action) => {
      state.metricOpportunityHeaderYears = action.payload
    },
    setMetricOpportunitySelectedGroup: (state, action) => {
      state.metricOpportunityHeaderFilterSelectedGroup = action.payload
    },
    setMetricOpportunitySelectedRegion: (state, action) => {
      state.metricOpportunityHeaderFilterSelectedRegion = action.payload
    },
    setMetricOpportunitySelectedPractice: (state, action) => {
      state.metricOpportunityHeaderFilterSelectedPractice = action.payload
    },
    setMetricOpportunitySelectedYear: (state, action) => {
      state.metricOpportunityHeaderFilterSelectedYear = action.payload
    },
    setMetricOpportunityTabs: (state, action) => {
      state.metricOpportunityTabs = action.payload
    },
    setSelectedMetricOpportunityTab: (state, action) => {
      state.selectedMetricOpportunityTab = action.payload
    },
    setSelectedOpportunityColumnFilters: (state, action) => {
      const { filterColor, headerIndex } = action.payload
      state.selectedOpportunityColumnFilters[headerIndex] = filterColor
    },
    setMetricOpportunityModalOpen: (state, action) => {
      state.metricOpportunityModalOpen = action.payload
    },
    setMetricOpportunityActiveRow: (state, action) => {
      state.metricOpportunityActiveRow = action.payload
    },
    setMetricOpportunityDetail: (state, action) => {
      state.metricOpportunityDetail = action.payload
    },
  },
})

export default metricSlice.reducer
export const {
  // common

  setMaevaGroups,
  setMaevaRegions,
  setMaevaPractices,
  setMaevaClasses,
  setMaevaSelectedGroups,
  setMaevaSelectedRegions,
  setMaevaSelectedPractices,
  setMaevaSelectedClasses,
  setMaevaSelectedGroupsNoAll,
  setMaevaSelectedRegionsNoAll,
  setMaevaSelectedPracticesNoAll,
  setMaevaSelectedClassesNoAll,
  setMaevaSelectedDateRange,

  setTabs,
  setGroups,
  setGroupList,
  setSelectedTab,
  setSelectedGroups,
  setSelectedBlueprintMetrics,
  setSelectedBlueprintMetricsEmpty,
  setMetricBMTableData,
  setMetricGoalsData,
  setMetricGoalsTableData,
  setMetricGoalsSelectedGroup,
  setMetricGoalsRegionList,
  setMetricGoalsSelectedRegion,
  setMetricGoalsPracticeList,
  setMetricGoalsSelectedPractice,
  setMetricGoalsSelectedYear,
  setMetricGoalsTabs,
  setSelectedMetricGoalsTab,
  setMetricGoalsYearList,
  setOpportunityGroupList,
  setOpportunitySelectedGroup,
  setOpportunityRegionList,
  setOpportunitySelectedRegion,
  setOpportunitySelectedYear,
  setSelectedOportunityTab,
  setOpportunityTabs,
  setOpportunityPracticeList,
  setOpportunitySelectedPractice,
  setOpporunityYearList,
  setOpportunityTableData,
  setOpportunityAdvisorList,
  setOpportunitySelectedAdvisor,
  setOpportunityStatusList,
  setOpportunityHeaderStatusList,
  setOpportunitySelectedStatusList,
  setOpportunityMoreColumns,
  setOpportunityName,
  setOppoortunityOfficeName,
  setOpportunityStatus,
  setOpportunityLogs,
  setOpportunityPracticeSk,
  setOpportunityRegion,
  setOpportunityGroupSk,
  setOppoortunityMetricId,
  setOpportunityEditGoalYear,
  setOpportunityEditGoalTable,
  setOpportunityAvailableYears,
  setOpportunityFetchId,
  setOpportunitySelectedStatus,
  setOpportunityViewHistorical,
  setMetricOpportunityData,
  setMetricOpportunityTableData,
  setMetricOpportunityTableDataFiltered,
  setExpandedD,
  setMetricOpportunityGroups,
  setMetricOpportunityRegions,
  setMetricOpportunityPractices,
  setMetricOpportunityYears,
  setMetricOpportunitySelectedGroup,
  setMetricOpportunitySelectedRegion,
  setMetricOpportunitySelectedPractice,
  setMetricOpportunitySelectedYear,
  setMetricOpportunityTabs,
  setSelectedMetricOpportunityTab,
  setSelectedOpportunityColumnFilters,
  setMetricOpportunityModalOpen,
  setMetricOpportunityActiveRow,
  setMetricOpportunityColumnFilterSelectValues,
  setMetricOpportunityDetail,
  setOpportunitySelectedGroupByRole,
  setOpportunityGroupListByRole,
} = metricSlice.actions
